import { PayloadAction } from '@reduxjs/toolkit';
import { put, select, takeLatest } from 'redux-saga/effects';
import { ProjectId, TaskId } from 'api/models';
import { Task, TaskAPI } from 'api/tasks';
import { FetchStatus } from 'data/core';
import { queryClient } from 'queries';
import { getProjectTasksQueryKey } from 'queries/common';
import { updateTaskPrivacySagaAction } from '../actions';
import { selectTask } from '../selectors';
import { saveTasks, updateTaskPrivacy } from '../slice';

function* updateTaskPrivacySaga({
  payload,
}: PayloadAction<{
  taskId: number;
  private: boolean;
  projectId: number;
  options?: { rejectCallback?: (value) => void };
}>): Generator {
  if (payload) {
    const { taskId, private: isPrivate, projectId, options } = payload;

    const oldTaskState = (yield select(
      selectTask(TaskId(projectId, taskId)),
    )) as Task | undefined;

    yield put(updateTaskPrivacy(payload));

    try {
      yield TaskAPI.updatePrivacy(taskId, {
        private: isPrivate,
      });
    } catch {
      if (oldTaskState) {
        if (options?.rejectCallback) {
          options.rejectCallback(oldTaskState);
        }
        yield put(
          saveTasks({ data: [oldTaskState], fetchStatus: FetchStatus.Loaded }),
        );
      }
    }

    yield queryClient.refetchQueries({
      predicate: (query) => {
        return (
          query.queryHash.includes('task-detail') &&
          query?.queryHash.includes(taskId.toString())
        );
      },
    });
    if (projectId) {
      yield queryClient.refetchQueries(
        getProjectTasksQueryKey(ProjectId(projectId)),
      );
    }
  }
}

export function* watchUpdateTaskPrivacySaga(): Generator {
  yield takeLatest(updateTaskPrivacySagaAction.type, updateTaskPrivacySaga);
}
